import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFlagIconSecondary from './svgs/FlagIconSecondary.js';
import SvgFlagIcon from './svgs/FlagIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var flagIcon = (props => useIcon(SvgFlagIcon, SvgFlagIconSecondary, props));

export { flagIcon as default };
